import React, { FC } from 'react';

import { PsychicCardHeading } from 'entities/PsychicCardHeading';
import { PsychicCardReadings } from 'entities/PsychicCardReadings';
import { PsychicCharacteristic } from 'entities/PsychicCharacteristic';
import { PsychicFeaturesArray } from 'entities/PsychicFeaturePallet';
import { PsychicCardStatusWrapper } from 'entities/PsychicCardStatusWrapper';
import { PsychicCtaButtons } from 'entities/PsychicCtaButton';
import { HiatusBar } from 'entities/HiatusBar';

import styles from './PsychicCardList.module.scss';
import MainImage from './MainImage';

import type { IMediumListCard } from '../config/declarations';

const MediumCard: FC<IMediumListCard> = ({
  psychicFrame,
  positionInArray,
  bootStatus,
  psychic,
  status,
  cta,
  linkProps,
  moreText,
  textLengthLimit,
}) => (
  <li className={styles.card}>
    <MainImage
      psychic={psychic}
      psychicFrame={psychicFrame}
      positionInArray={positionInArray}
      linkProps={linkProps}
      styles={styles}
    />
    <div className={styles.first}>
      <PsychicCardHeading
        nameClassName={styles.name}
        psychic={psychic}
        linkProps={linkProps}
        psychicFrame={psychicFrame}
      />
      <PsychicCardReadings
        psychic={psychic}
        psychicFrame={psychicFrame}
        className={styles.readings}
      />
      <PsychicCharacteristic
        text={psychic.latestTestimonial}
        linkProps={linkProps}
        moreLabel={moreText}
        className={styles.characteristic}
        textLengthLimit={textLengthLimit}
      />
    </div>
    <div className={styles.second}>
      <PsychicFeaturesArray
        features={psychic.specialities}
        className={styles.features}
      />
      <PsychicCardStatusWrapper
        status={status}
        psychic={psychic}
        psychicFrame={psychicFrame}
      />
      {!psychic.onHiatus && (
        <PsychicCtaButtons
          bootStatus={bootStatus}
          className={styles.interaction}
          chatButton={cta.chatButton}
          talkButton={cta.talkButton}
          callbackButton={cta.callbackButton}
          inQueueButton={cta.inQueueButton}
          messageButton={cta.messageButton}
          psychicFrame={psychicFrame}
          psychic={psychic}
          shape="Oval"
        />
      )}
      <HiatusBar
        psychic={psychic}
        contentfulData={psychicFrame}
        className={styles.hiatus}
      />
    </div>
  </li>
);

export default MediumCard;
